import {XauditModel} from '../xaudit.model';

export class OperatoryDataModel extends XauditModel {
  LOCID: number;
  OperatoryDescription: string;
  OperatoryId: string;
  OperatoryName: string;
  OperatoryOrder: number;
  avatar: string;
  color: string;
}
